<template>
  <footer>
    <div style="padding: 20px 40px;overflow: hidden;">
      <img class="img"
        :src="!china ? require('../assets/logo-vertical-white-en.png') : require('../assets/logo-vertical-white.png')" />
    </div>
    <div class="row">
      <div class="right">
        <p @click="$routeChange('about')">{{ lang.aboutUs }}</p>
        <p @click="$routeChange('connection')">{{ lang.contactUs }}</p>
        <p><a v-bind:href="joinUsSocalLink">{{ lang.joinUs_1 }}</a></p>
        <p><a v-bind:href="joinUsCampusLink">{{ lang.joinUs_2 }}</a></p>
      </div>
    </div>
    <div class="row-bottom">
      <p class="p1" style="color: #f8f8f8">{{ lang.geelyFintech }}</p>
      <a href="http://beian.miit.gov.cn" style="color: #f8f8f8;"> Copyright © 2020<span> 渝ICP备2020012418号 </span></a>
      <!-- <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002502329"
        style="margin-top: 10px;display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="../assets/batb.png" style="float:left;" />
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#f8f8f8;">渝公网安备 50019002502329号
        </p>
      </a> -->
    </div>
  </footer>
</template>
<script>
import mapStore from '@/mixins/mapStore'
export default {
  name: 'pageFooter',
  mixins: [
    mapStore('', {
      getters: ['lang', 'china']
    })
  ],
  data() {
    return {
      joinUsSocalLink: process.env.VUE_APP_MOKA_SOCIAL_LINK || '/join',
      joinUsCampusLink: process.env.VUE_APP_MOKA_CAMPUS_LINK || '/join'
    }
  }
};
</script>
<style lang="less" scoped>
footer {
  background: #243F72;
  padding-bottom: 30px;
}

.row {
  color: white;
  padding-bottom: 10px;
  overflow: hidden;
  position: relative;

  a {
    color: #fff;
  }

  .left {
    float: left;
    width: 50%;
    padding-left: 40px;

    .l-div {
      height: 24px;

      img {
        display: block;
        float: left;
        width: 24px;
        height: 24px;
      }

      span {
        float: left;
        display: block;
        line-height: 24px;
        margin-left: 15px;
        font-size: 14px;
      }
    }

    .tel {
      margin-top: 15px;
      font-size: 14px;
      line-height: 20px;
      color: #9FA4A8;
    }
  }

  .right {
    float: left;
    padding: 0 40px;

    p {
      display: block;
      float: left;
      font-size: 14px;
      margin-bottom: 15px;
      line-height: 24px;
      margin-right: 35px;
    }

    p:last-child {
      margin-right: 0;
    }
  }

  &::after {
    position: absolute;
    width: calc(100% - 80px);
    height: 1px;
    content: '';
    clear: both;
    background: #fff;
    left: 40px;
    bottom: 0;
    opacity: 0.2;
  }
}

.row-bottom {
  color: #F8F8F8;
  padding-left: 40px;
  font-size: 14px;

  .p1 {
    padding-top: 20px;
    padding-bottom: 10px;
    line-height: 20px;
  }

  span {
    margin-left: 15px;
  }
}

.img {
  display: block;
  float: left;
  height: 36px;
}
</style>